export function appendPreloadImage(href: string, id: string): void {
  const existing = document.getElementById(id);

  if (existing?.getAttribute("href") === href) {
    return;
  }

  existing?.remove();

  const link = document.createElement("link");
  link.id = id;
  link.rel = "preload";
  link.as = "image";
  link.href = href;
  link.setAttribute("fetchpriority", "high");

  try {
    if (new URL(href, location.href).origin !== location.origin) {
      link.crossOrigin = "anonymous";
    }
  } catch {
    // invalid href: leave default
  }

  document.head.appendChild(link);
}
